import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCaretUp } from '@redteclab/icons'

import { Button } from 'base-ui'

export const ProductBuyBoxStickyScrollToVariantSelection: FC<{
  className?: string
}> = ({ className }) => {
  return (
    <Button
      className={className}
      data-qa-id="sticky-buy-box-scroll-to-variant-selection"
      onClick={(): void => {
        window.scrollTo({ behavior: 'smooth', top: 0 })
      }}
    >
      <IconCaretUp />
      <FormattedMessage id="variantAttributes.message.selectProductVariant" />
    </Button>
  )
}
